import React, { FunctionComponent } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from '@matematykagryzie/ui';

export const Config: FunctionComponent = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};
